// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1ga78","row":"Node_row__2CYB_","label":"Node_label__1ZiEd","footer":"Node_footer__1IV4i"};